<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->

<script context="module">
  
    export const FootnoteDefaults = {
        "name": "footnote",

        "outer-container": { 
            "style": {
                "font-size": "0.8rem",
                "opacity": "0.6"
            }
        },

        "text": {
            "name": "text",
            "style": {},
            "innerText": "This is a footnote"
        }, 

        "meta": {
            "order": {
                "text": 0
            }
        }
        
    }
    
</script>

<script>


</script>

<p data-i-name="text" />

<style>

</style>